import { useState } from 'react'
import { Link } from 'react-router-dom'
import Eye from 'components/assets/icons/Eye'
import EyeClosed from 'components/assets/icons/EyeClosed'
import style from './LoginLayout.module.scss'

// Briques de formulaire du nouveau design (aux couleurs du brand via les variables --lg-*).

export const Field = ({ id, label, type = 'text', placeholder, autoComplete, register, error, children }) => {
  const [shown, setShown] = useState(false)
  const isPassword = type === 'password'

  return (
    <div className={style.field}>
      <label htmlFor={id}>{label}</label>
      <div className={style.password}>
        <input
          id={id}
          type={isPassword && shown ? 'text' : type}
          placeholder={placeholder}
          autoComplete={autoComplete}
          {...register}
        />
        {isPassword && (
          <button type="button" className={style.eye} onClick={() => setShown(!shown)} aria-label="toggle password">
            {shown ? <EyeClosed /> : <Eye />}
          </button>
        )}
      </div>
      {error && <div className={style['field-error']}>{error}</div>}
      {children}
    </div>
  )
}

export const SubmitButton = ({ label, disabled, loading, onClick, type = 'submit' }) => (
  <button type={type} className={style.submit} disabled={disabled || loading} onClick={onClick}>
    {loading ? '…' : label}
  </button>
)

export const AuthLink = ({ to, label, onClick, className }) => (
  <Link className={className || style.link} to={to} onClick={onClick}>{label}</Link>
)

export const AuthMessage = ({ children, type }) => (
  <div className={type === 'success' ? style.success : style.error} role="alert">{children}</div>
)

export const AuthAlt = ({ children }) => <p className={style.alt}>{children}</p>
